import { Route, Routes } from 'react-router-dom';
import CustomRouter from '../utils/CustomRouter';
import history from '../utils/history';
import NotFound from '../NotFound';
import RootLayout from '../layout';
import HomePage from '../page';
import CarsPage from '../cars/page';
import CarDetailsPage from '../cars/detail/page';

const AppRoutes = () => (
  <CustomRouter history={history}>
    <Routes>
      <Route path="/" element={<RootLayout />}>
        <Route index element={<HomePage/>}/>
        <Route path="cars" element={<CarsPage/>}/>
        <Route path="cars/:slug" element={<CarDetailsPage/>}/>
        <Route path="*" element={<NotFound/>}/>
      </Route>
    </Routes>
  </CustomRouter>
);

export default AppRoutes;
